import React, { useEffect, useRef, useState } from 'react';
import KanbanHeader from './KanbanHeader';
import KanbanContainer from './KanbanContainer';
import { useAppContext } from 'providers/AppProvider';
import KanbanProvider from 'providers/KanbanProvider';
import { Card, Col, Form, Nav, Row, Tab, OverlayTrigger, Tooltip, Alert } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import axios from 'helpers/api';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { socket } from '../../../socket';
import { useNavigate, useParams } from 'react-router-dom'
import siteMaps from 'routes/siteMaps';
import paths from '../../../routes/paths';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';
import { Link } from 'react-router-dom';
import ColorStatusLegend from 'components/common/ColorStatusLegend';
import { Button } from "react-bootstrap";
import Select from "react-select";
import { useErrorBoundary } from 'react-error-boundary';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';
import { storeList, getStoredStoreId, setStoredStoreId } from 'components/common/StoreList';

const AUTO_MANUAL_ROBOTS = [
  'yuyama_fitch',
  'yuyama_walth',
  'yuyama_walt',
  'synmed_brt',
  'parata_brt'
];

const isAutoManualRobot = (robotName) => {
  if (!robotName) return false;
  const normalized = String(robotName).trim().toLowerCase().replace(/[\s-]+/g, '_');
  return AUTO_MANUAL_ROBOTS.some(target => normalized === target || normalized.includes(target) || target.includes(normalized));
};

const ROBOT_DISPLAY_MAP = {
  'dosis_brt': 'Unit-Dose - Brockton',
  'dosis_fitch': 'Unit-Dose - Fitchburg',
  'synmed_brt': 'Multidose - Brockton',
  'yuyama_fitch': 'Multidose - Fitchburg',
  'yuyama_walt': 'Multidose - Waltham',
  'yuyama_walth': 'Multidose - Waltham',
  'parata_brt': 'Multidose - Brockton',
};

const getRobotDisplayName = (robot) => {
  if (!robot) return '';
  const trimmed = String(robot).trim();
  const normalizedKey = trimmed.toLowerCase().replace(/[\s-]+/g, '_');

  if (ROBOT_DISPLAY_MAP[normalizedKey]) {
    return ROBOT_DISPLAY_MAP[normalizedKey];
  }

  const parts = normalizedKey.split('_');
  if (parts.length >= 2) {
    const prefix = parts[0];
    const suffix = parts[parts.length - 1];

    let typeLabel = prefix.toUpperCase();
    if (prefix === 'dosis') typeLabel = 'Unit-Dose';
    else if (['synmed', 'yuyama', 'parata'].includes(prefix)) typeLabel = 'Multidose';

    let locLabel = suffix.toUpperCase();
    if (suffix === 'brt') locLabel = 'Brockton';
    else if (suffix === 'fitch') locLabel = 'Fitchburg';
    else if (suffix === 'walt' || suffix === 'walth') locLabel = 'Waltham';

    return `${typeLabel} - ${locLabel}`;
  }

  return trimmed;
};

const CycleView = () => {

  var tempArray = [];
  var tempCount = 0;
  const navigate = useNavigate();
  const {
    config: { isFluid, isNavbarVerticalCollapsed },
    setConfig
  } = useAppContext();
  const [cycleIsFluid] = useState(isFluid);
  const [cycleIsNavbarVerticalCollapsed] = useState(isNavbarVerticalCollapsed);
  const [pageNo, setpageNo] = useState(1);
  const [cycleData, setCycleData] = useState([]);
  const [filteredCycleData, setFilteredCycleData] = useState([]);
  const [cycleDataIdwise, setcycleDataIdwise] = useState([]);
  const [cycleDates, setCycleDates] = useState([]);
  const [cycleLoaderids, setCycleLoaderids] = useState([]);
  const { id } = useParams();
  const weekPages = [0, 1, 2, 3, 4];
  const pageNumber = id !== undefined ? Number(id) : 1;
  const groupList = JSON.parse(localStorage.getItem("groupsData")) || [];
  const facilityList = JSON.parse(localStorage.getItem("facilitiesData")) || [];
  const [groupOptions] = useState([{ key: "All Groups", value: "" }, ...groupList]);
  const [facilityOptions, setFacilityOptions] = useState([{ key: "All Facilities", value: "" }, ...facilityList]);
  const [storeOptions] = useState([{ key: "All Stores", value: "" }, ...storeList]);
  const savedStoreId = getStoredStoreId();
  const initialStoreOption = storeOptions.find(opt => String(opt.value) === String(savedStoreId)) || '';
  const [selectedGroup, setSelectedGroup] = useState('');
  const [selectedGroupValue, setSelectedGroupValue] = useState('');
  const [selectedStore, setSelectedStore] = useState(savedStoreId ? (Number(savedStoreId) || savedStoreId) : '');
  const [selectedStoreValue, setSelectedStoreValue] = useState(initialStoreOption);
  const [selectedRobot, setSelectedRobot] = useState('');
  const [selectedRobotValue, setSelectedRobotValue] = useState('');
  const [selectedFacilityValue, setSelectedFacilityValue] = useState('');
  const [robotOptions, setRobotOptions] = useState([{ key: "All", value: "" }]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false); 
  const startOfWeek = moment().startOf('isoWeek').subtract(1, 'week');
  const pageNumberRef = useRef(pageNumber);
  const processedTimestampsRef = useRef(new Set());
  const dates = [];
  for (let i = 0; i < 5; i++) {
    dates.push(startOfWeek.clone().add(i, 'weeks').format('MMMM DD'));
  }


  const [isChecked, setIsChecked] = useState(false);

  const cycleStageOrder = [
    { checktype: 'refill', field: 'refill' },
    { checktype: 'billed', field: 'billed_status' },
    { checktype: 'tcgrx', field: 'tcgrx_fill' },
    { checktype: 'manual', field: 'manual_fill' },
    { checktype: 'pv2', field: 'pv2_status' },
    { checktype: 'manifest', field: 'manifest' }
  ];

  const isStageChecked = (item, field) => item?.[field] == 1 || item?.[field] === true;

  const canChangeCycleStage = (item, checktype, checked) => {
    if (checktype === 'manual' && !checked && isAutoManualRobot(item?.robot) && isStageChecked(item, 'tcgrx_fill')) {
      return false;
    }

    const stageIndex = cycleStageOrder.findIndex(stage => stage.checktype === checktype);
    if (stageIndex === 0) {
      return true;
    }

    if (checked) {
      return cycleStageOrder
        .slice(0, stageIndex)
        .every(stage => isStageChecked(item, stage.field));
    }

    if (checktype === 'tcgrx' && !checked && isAutoManualRobot(item?.robot)) {
      return cycleStageOrder
        .slice(stageIndex + 2)
        .every(stage => !isStageChecked(item, stage.field));
    }

    return cycleStageOrder
      .slice(stageIndex + 1)
      .every(stage => !isStageChecked(item, stage.field));
  };

  const isCycleStageDisabled = (item, checktype) => {
    if (checktype === 'manual' && isAutoManualRobot(item?.robot) && isStageChecked(item, 'tcgrx_fill')) {
      return true;
    }

    const stage = cycleStageOrder.find(stage => stage.checktype === checktype);
    const isChecked = stage ? isStageChecked(item, stage.field) : false;

    return !canChangeCycleStage(item, checktype, !isChecked);
  };

  const getCycleCardStatusConfig = item => {
    // Ordered furthest-along first: the first match wins, so a cycle that has
    // reached manifest is shown as manifest even if earlier flags are still set.
    const statusPriority = [
      { isActive: item.manifest == 1, sortRank: 7, bgColor: 'bg-brown', fgColorHeader: 'text-white' },
      { isActive: item.pv2_status == 1, sortRank: 6, bgColor: 'bg-green', fgColorHeader: 'text-white' },
      { isActive: item.manual_fill == 1, sortRank: 5, bgColor: 'bg-purple', fgColorHeader: 'text-white' },
      { isActive: item.tcgrx_fill == 1, sortRank: 4, bgColor: 'bg-blue', fgColorHeader: 'text-white' },
      { isActive: item.billed_status == 1, sortRank: 3, bgColor: 'bg-peach', fgColorHeader: 'text-white' },
      { isActive: item.refill == 1, sortRank: 2, bgColor: 'bg-darkgreen', fgColorHeader: 'text-white' }
    ];

    const activeStatus = statusPriority.find(status => status.isActive);
    if (activeStatus) {
      return activeStatus;
    }

    if (item.census == 1) {
      return { sortRank: 1, bgColor: 'bg-yellow', fgColorHeader: 'text-dark' };
    }

    return { sortRank: 0, bgColor: 'bg-orange', fgColorHeader: 'text-white' };
  };

  const handleCheckboxChange = async (e) => {
    const { deliverydate, headerid, checktype } = e.target.dataset;
    const { checked } = e.target;
    let cycleItem = cycleDataIdwise[headerid];
    if (!cycleItem) {
      for (const date in filteredCycleData) {
        const found = filteredCycleData[date]?.find(i => String(i.id) === String(headerid));
        if (found) {
          cycleItem = found;
          break;
        }
      }
    }

    if (!canChangeCycleStage(cycleItem, checktype, checked)) {
      e.target.checked = !checked;
      return;
    }

    const cardEl = document.getElementById("cycleViewCard" + headerid);
    if (cardEl) {
      cardEl.classList.add('loader');
    }

    let tokenStr = localStorage.getItem("accessToken");
    let data = { cycle_id: headerid };

    const shouldAutoCheckManual = (checktype === 'tcgrx' && checked && isAutoManualRobot(cycleItem?.robot));
    const shouldAutoUncheckManual = (checktype === 'tcgrx' && !checked && isAutoManualRobot(cycleItem?.robot));

    switch (checktype) {
      case 'refill':
        data.refill = checked ? 1 : 0;
        break;
      case 'billed':
        data.billed = checked ? 1 : 0;
        break;
      case 'tcgrx':
        data.tcgrx_fill = checked ? 1 : 0;
        if (shouldAutoCheckManual) {
          data.manual_fill = 1;
        }
        if (shouldAutoUncheckManual) {
          data.manual_fill = 0;
        }
        break;
      case 'manual':
        data.manual_fill = checked ? 1 : 0;
        break;
      case 'pv2':
        data.pv2_status = checked ? 1 : 0;
        break;
      case 'manifest':
        data.manifest = checked ? 1 : 0;
        break;
      default:
        break;
    }

    const updateItemState = (item) => {
      const newItem = { ...item };
      if (checktype === 'refill') newItem.refill = checked ? 1 : 0;
      if (checktype === 'billed') newItem.billed_status = checked ? 1 : 0;
      if (checktype === 'tcgrx') newItem.tcgrx_fill = checked ? 1 : 0;
      if (checktype === 'manual') newItem.manual_fill = checked ? 1 : 0;
      if (checktype === 'pv2') newItem.pv2_status = checked ? 1 : 0;
      if (checktype === 'manifest') newItem.manifest = checked ? 1 : 0;

      if (shouldAutoCheckManual) {
        newItem.manual_fill = 1;
      }
      if (shouldAutoUncheckManual) {
        newItem.manual_fill = 0;
      }
      const statusConfig = getCycleCardStatusConfig(newItem);
      newItem.sortRank = statusConfig.sortRank;
      newItem.bgColor = statusConfig.bgColor;
      newItem.fgColorHeader = statusConfig.fgColorHeader;
      return newItem;
    };

    setcycleDataIdwise(prevData => {
      if (!prevData[headerid]) return prevData;
      return {
        ...prevData,
        [headerid]: updateItemState(prevData[headerid])
      };
    });

    setFilteredCycleData(prevFiltered => {
      const newFiltered = { ...prevFiltered };
      for (const date in newFiltered) {
        newFiltered[date] = newFiltered[date].map(item => {
          if (String(item.id) === String(headerid)) {
            return updateItemState(item);
          }
          return item;
        });
      }
      return newFiltered;
    });

    setCycleData(prevCycleData => {
      const newCycleData = { ...prevCycleData };
      for (const date in newCycleData) {
        newCycleData[date] = newCycleData[date].map(item => {
          if (String(item.id) === String(headerid)) {
            return updateItemState(item);
          }
          return item;
        });
      }
      return newCycleData;
    });

    try {
      await axios.post(`${process.env.REACT_APP_SERVER_URL}/cycles/update-cycle`, data, {
        headers: { 'Authorization': `Bearer ${tokenStr}` }
      });
      if (shouldAutoCheckManual) {
        await axios.post(`${process.env.REACT_APP_SERVER_URL}/cycles/update-cycle`, { cycle_id: headerid, manual_fill: 1 }, {
          headers: { 'Authorization': `Bearer ${tokenStr}` }
        });
      }
      if (shouldAutoUncheckManual) {
        await axios.post(`${process.env.REACT_APP_SERVER_URL}/cycles/update-cycle`, { cycle_id: headerid, manual_fill: 0 }, {
          headers: { 'Authorization': `Bearer ${tokenStr}` }
        });
      }
    } catch (error) {
      console.error('Error updating cycle data:', error);
      if (cardEl) {
        cardEl.classList.remove('loader');
      }
    }
  };

  const handleCycleDataUpdated = async (data) => {
    const timestamp = data.maxUpdatedTimestamp;

    if (!timestamp || processedTimestampsRef.current.has(timestamp)) {
      console.log('Duplicate or missing timestamp. Skipping update.');
      return;
    }

    processedTimestampsRef.current.add(timestamp);

    console.log('New timestamp detected:', timestamp);
    await getCycleViewData(pageNumberRef.current);
  };


  useEffect(() => {
    const facilitiesData = JSON.parse(localStorage.getItem("facilitiesData")) || [];

    if (selectedGroup) {
      const filteredFacilities = facilitiesData
        .filter(facility => Number(facility.group_id) === Number(selectedGroup))
        .map(facility => ({ key: facility.key, value: facility.value }));

      setFacilityOptions([{ key: "All Facilities", value: "" }, ...filteredFacilities]);
    } else {
      const allFacilities = facilitiesData
        .map(facility => ({ key: facility.key, value: facility.value }));

      setFacilityOptions([{ key: "All Facilities", value: "" }, ...allFacilities]);
    }
  }, [selectedGroup]);

  useEffect(() => {
    pageNumberRef.current = pageNumber;
  }, [pageNumber]);


  const handleAcknowledgeChange = async (e) => {
    const { deliverydate, headerid, checktype } = e.target.dataset;
    const { checked } = e.target;

    document.getElementById("cycleViewCard" + headerid).classList.add('loader');

    //console.log('handleAcknowledgeChange', "cycleViewCard" + headerid, e.target, checked);

    let tokenStr = localStorage.getItem("accessToken");
    let data = { cycle_id: headerid };
    data.need_acknowledgement = 1;

    if (checked) {
      data.need_acknowledgement = 0;
    }

    try {
      await axios.post(`${process.env.REACT_APP_SERVER_URL}/cycles/update-need-acknowledgement`, data, {
        headers: { 'Authorization': `Bearer ${tokenStr}` }
      }).then((response) => {
        //console.log('response', response);
        if (response.data.status) {
          //console.log('Cycle data updated successfully');
          // setTimeout(() => {
          //   document.getElementById("cycleViewCard" + headerid).classList.remove('loader');
          // }, 1000);
        }
      });
    } catch (error) {
      console.error('Error updating cycle data:', error);
      document.getElementById("cycleViewCard" + headerid).classList.remove('loader');
    }
  };

  useEffect(() => {
    tempArray.push(++tempCount + ' - 1 ' + moment().format('YYYY-MM-DD HH:mm:ss'));
    let tokenStr = localStorage.getItem("accessToken");
    // set pageNo to 1 on initial load
    setpageNo(1);

    setConfig('isFluid', true);
    setConfig('isNavbarVerticalCollapsed', true);


    function onConnect() {
      // setIsConnected(true);
    }

    function onDisconnect() {
      console.log('Disconnected from server');
      // setIsConnected(false);
    }

    // function onFooEvent(value) {
    //   console.log('getCycleViewData getCycleViewData ');
    //   socket.emit('clearAllCycles', { tokenStr:tokenStr });
    //   // setFooEvents(previous => [...previous, value]);
    // }

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    // socket.on('getCycleViewData', onFooEvent);

    socket.emit('getCycleViewData', { tokenStr: tokenStr, pageNo: 1 });

    // The server broadcasts 'cycleDataUpdated' to every user at the same moment.
    // Wait a random 0-3 s before re-fetching so those requests to pharmacysys
    // are spread out instead of arriving together. Several updates inside the
    // window = one fetch (for the latest timestamp).
    const REFETCH_SPREAD_MS = 3000;
    let refetchTimer = null;
    function onCycleDataUpdated(data) {
      clearTimeout(refetchTimer);
      refetchTimer = setTimeout(() => handleCycleDataUpdated(data), Math.random() * REFETCH_SPREAD_MS);
    }
    socket.on('cycleDataUpdated', onCycleDataUpdated);


    // call getCycleViewData with pageNo
    getCycleViewData(pageNo);

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      // Without this, every visit to the page (and every page change) added one
      // more listener, so one update fetched the dashboard several times.
      socket.off('cycleDataUpdated', onCycleDataUpdated);
      clearTimeout(refetchTimer);
      // socket.off('foo', onFooEvent);

      console.log('Disconnected from server');

      socket.emit('clearAllCycles', { tokenStr: tokenStr });

      setConfig('isFluid', false);
      setConfig('isNavbarVerticalCollapsed', false);
    };
  }, [pageNumber]);

  async function getCycleViewData(pageNo) {
    let tokenStr = localStorage.getItem("accessToken");
    try {
      setIsLoading(true);
      const { data } = await axios.get(`${process.env.REACT_APP_PHARMACY_SERVER_URL}` + "/cycles/cycle-dashboard/" + pageNumberRef.current, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
      var temp = {};
      var dateCount = {};
      Object.keys(data.cycleView).map(date => {
        if (!dateCount.hasOwnProperty(date)) {
          dateCount[date] = {
            total: 0,
            pv2Count: 0
          };
        }
        data.cycleView[date].map(item => {
          dateCount[date].total++;
          if (item.pv2_status != 0) {
            dateCount[date].pv2Count++;
          }
          if ((item.tcgrx_fill == 1 || item.tcgrx_fill === true) && isAutoManualRobot(item.robot)) {
            item.manual_fill = 1;
          }
          const statusConfig = getCycleCardStatusConfig(item);
          item.sortRank = statusConfig.sortRank;
          item.bgColor = statusConfig.bgColor;
          item.fgColorHeader = statusConfig.fgColorHeader;
          temp[item.id] = item;
          if (selectedGroup && item.group_id !== selectedGroup) {
            setIsError(true);
            return;
          }
          if (selectedStore && item.store_id !== selectedStore) {
            setIsError(true);
            return;
          }
          Object.keys(temp).forEach(id => {
            const cycleCard = document.getElementById("cycleViewCard" + id);
            if (cycleCard) {
              setTimeout(() => {
                cycleCard.classList.remove('loader');
              }, 100);
            }
          });
        });
        data.cycleView[date].sort((a, b) => a.sortRank - b.sortRank);
      });

      if (data && data.cycleView) {
        setCycleDates(dateCount);
        setcycleDataIdwise(temp);
        setCycleData(data.cycleView);
        applyCycleFilters({
          group: selectedGroup,
          facility: selectedFacilityValue?.value || '',
          store: selectedStore,
          robot: selectedRobot
        }, data.cycleView);

        // Extract unique robot values for dropdown (excluding FAKE)
        const robotSet = new Set();
        Object.keys(data.cycleView).forEach(date => {
          data.cycleView[date].forEach(item => {
            if (item.robot !== undefined && item.robot !== null && item.robot !== '' && item.robot.trim().toUpperCase() !== 'FAKE') {
              robotSet.add(item.robot);
            }
          });
        });
        const robotOpts = [{ key: "All", value: "" }, ...Array.from(robotSet).sort().map(r => ({ key: getRobotDisplayName(r), value: r }))];
        setRobotOptions(robotOpts);
      } else {
        setIsError(true);
      }
    } catch (error) {
      console.error('Error fetching cycle data:', error);
      // setIsError(true);
      navigate('/error')
    } finally {
      setIsLoading(false);
    }
  }

  const processData = () => {
    for (const date in cycleData) {
      if (cycleData.hasOwnProperty(date)) {
        const arrayForDate = cycleData[date];
        // Process each array item
        arrayForDate.forEach(item => {
          //console.log(`Processing item for date ${date}:`, item);
        });
      }
    }
  };

  useEffect(() => {
    //console.log('tempArray', tempArray);
    if (Object.keys(cycleData).length > 0) {
      // processData();
    }
  }, [cycleData]);

  const handleUpdateCardBodyClick = (facilityid) => {
    //console.log("cardbody" + facilityid);
    //navigate(paths.cycleDelivery(facilityid), { state: { facilityId: facilityid } });
    // navigate(paths.cycleDelivery(facilityid));
    const url = paths.cycleDelivery(facilityid);
    window.open(url, '_blank'); // opens in a new tab
  }

  const handleCardBodyClick = (facilityid) => {
    //console.log("cardbody" + facilityid);
    //navigate(paths.cycleDelivery(facilityid), { state: { facilityId: facilityid } });
    navigate(paths.cycleDelivery(facilityid));
  }

  const getFilteredCycleData = (filters, sourceData = cycleData) => {
    return Object.keys(sourceData).reduce((result, date) => {
      const filteredItems = sourceData[date].filter(item => {
        const matchesGroup = !filters.group || Number(item.group_id) === Number(filters.group);
        const matchesFacility = !filters.facility || Number(item.facility_id) === Number(filters.facility);
        const matchesStore = !filters.store || Number(item.store_id) === Number(filters.store);
        const matchesRobot = !filters.robot || item.robot === filters.robot;

        return matchesGroup && matchesFacility && matchesStore && matchesRobot;
      });

      if (filteredItems.length > 0) {
        result[date] = filteredItems;
      }

      return result;
    }, {});
  };

  const applyCycleFilters = (filters, sourceData = cycleData) => {
    const filteredData = getFilteredCycleData(filters, sourceData);
    const hasActiveFilters = Object.values(filters).some(Boolean);
    const hasMatchingData = Object.keys(filteredData).length > 0;
    const dataToShow = hasActiveFilters ? filteredData : sourceData;

    setIsError(hasActiveFilters && !hasMatchingData);
    setFilteredCycleData(dataToShow);
    updateCycleDateCounts(dataToShow);
  };

  const handleGroupChange = (e) => {
    const selectedGroupId = e.value;
    if (selectedGroupId === selectedGroup) return;

    setSelectedGroup(selectedGroupId);
    setSelectedGroupValue(e);

    applyCycleFilters({
      group: selectedGroupId,
      facility: selectedFacilityValue?.value || '',
      store: selectedStore,
      robot: selectedRobot
    });
  };

  const handleFacilityChange = (e) => {
    const selectedFacilityId = e.value;
    const currentFacilityId = selectedFacilityValue ? selectedFacilityValue.value : '';
    if (selectedFacilityId === currentFacilityId) return;

    setSelectedFacilityValue(e);

    applyCycleFilters({
      group: selectedGroup,
      facility: selectedFacilityId,
      store: selectedStore,
      robot: selectedRobot
    });
  };


  const handleStoreChange = (e) => {
    const selectedStoreId = e ? e.value : '';
    setStoredStoreId(selectedStoreId);
    if (selectedStoreId === selectedStore) return;

    setSelectedStore(selectedStoreId);
    setSelectedStoreValue(e);

    applyCycleFilters({
      group: selectedGroup,
      facility: selectedFacilityValue?.value || '',
      store: selectedStoreId,
      robot: selectedRobot
    });
  };

  const handleRobotChange = (e) => {
    const selectedRobotVal = e.value;
    if (selectedRobotVal === selectedRobot) return;

    setSelectedRobot(selectedRobotVal);
    setSelectedRobotValue(e);

    applyCycleFilters({
      group: selectedGroup,
      facility: selectedFacilityValue?.value || '',
      store: selectedStore,
      robot: selectedRobotVal
    });
  };

  const updateCycleDateCounts = (dataObj) => {
    const dateCount = {};

    Object.keys(dataObj).forEach(date => {
      if (!dateCount[date]) {
        dateCount[date] = { total: 0, pv2Count: 0 };
      }

      dataObj[date].forEach(item => {
        dateCount[date].total++;
        if (item.pv2_status !== 0) {
          dateCount[date].pv2Count++;
        }
      });
    });

    setCycleDates(dateCount);
  };



  const breadcrumbItems = [
    { name: 'Dashboard', href: '/main', isActive: false },
    { name: 'Cycle-View', href: paths.cycleView, isActive: true }
  ];
  const cycleView = paths.cycleView

  const handlePageChange = (newPage) => {
    setSelectedGroup('');
    setSelectedGroupValue('');
    setSelectedFacilityValue('');
    setSelectedRobot('');
    setSelectedRobotValue('');
    navigate(incrementLastNumber(cycleView, newPage));
  };

  function incrementLastNumber(inputString, target) {
    const parts = inputString.split("/");
    parts[parts.length - 1] = target.toString();
    return parts.join("/");
  }

  const handleDateNavigation = (index) => {
    setSelectedGroup('');
    setSelectedGroupValue('');
    setSelectedFacilityValue('');
    setSelectedRobot('');
    setSelectedRobotValue('');
    setIsError(false);
    navigate(incrementLastNumber(cycleView, weekPages[index]));
  };


  return (
    <>
      <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
      <Card className="p-3 pt-3 pb-4 mb-4">
        <div className="filters-section rounded position-relative">
          <Row className='mb-3'>
            <Col md={5} className="d-flex align-items-center flex-wrap">
              {dates.map((date, index) => {
                const targetPage = weekPages[index];
                const isCurrentWeek = index === 1;
                const isPreviousWeek = index === 0;
                const isActivePage = pageNumber === targetPage;

                return (
                  <React.Fragment key={index}>
                    <Link
                      onClick={() => handleDateNavigation(index)}
                      className={`text-decoration-none ${isActivePage ? 'fw-bold text-primary' : 'fw-bold'}`}
                      style={{
                        textDecoration: isCurrentWeek ? 'underline' : 'none',
                        textUnderlineOffset: isCurrentWeek ? '4px' : undefined,
                        textDecorationThickness: isCurrentWeek ? '2px' : undefined,
                        opacity: isPreviousWeek ? 0.65 : 1,
                      }}
                    >
                      {date}
                    </Link>
                    {index < dates.length - 1 && <span className="mx-2">/</span>}
                  </React.Fragment>
                );
              })}
            </Col>
            <Col md={7}>
              <ColorStatusLegend />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Store</Form.Label>
                <ThemedSelect
                  name="store"
                  closeMenuOnSelect={true}
                  placeholder='All stores'
                  classNamePrefix="react-select"
                  options={storeOptions}
                  value={selectedStoreValue}
                  getOptionLabel={option => option.key}
                  getOptionValue={option => option.value}
                  onChange={(e) => handleStoreChange(e)}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      borderColor: "#ced4da",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#80bdff" },
                    }),
                    option: (provided, { isFocused, isSelected }) => ({
                      ...provided,
                      backgroundColor: isSelected ? "#e9ecef !important" : isFocused ? "#f8f9fa !important" : "white !important",
                      color: isSelected ? "#212529 !important" : "#212529 !important",
                      cursor: "pointer",
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: "#212529",
                    }),
                  }}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Robot</Form.Label>
                <ThemedSelect
                  name="robot"
                  closeMenuOnSelect={true}
                  placeholder='All'
                  classNamePrefix="react-select"
                  options={robotOptions}
                  value={selectedRobotValue}
                  getOptionLabel={option => option.key}
                  getOptionValue={option => option.value}
                  onChange={(e) => handleRobotChange(e)}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      borderColor: "#ced4da",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#80bdff" },
                    }),
                    option: (provided, { isFocused, isSelected }) => ({
                      ...provided,
                      backgroundColor: isSelected ? "#e9ecef !important" : isFocused ? "#f8f9fa !important" : "white !important",
                      color: isSelected ? "#212529 !important" : "#212529 !important",
                      cursor: "pointer",
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: "#212529",
                    }),
                  }}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Group</Form.Label>
                <ThemedSelect
                  name="group"
                  closeMenuOnSelect={true}
                  placeholder='All Groups'
                  classNamePrefix="react-select"
                  options={groupOptions}
                  value={selectedGroupValue}
                  getOptionLabel={option => option.key}
                  getOptionValue={option => option.value}
                  onChange={(e) => handleGroupChange(e)}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      borderColor: "#ced4da",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#80bdff" },
                    }),
                    option: (provided, { isFocused, isSelected }) => ({
                      ...provided,
                      backgroundColor: isSelected ? "#e9ecef !important" : isFocused ? "#f8f9fa !important" : "white !important",
                      color: isSelected ? "#212529 !important" : "#212529 !important",
                      cursor: "pointer",
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: "#212529",
                    }),
                  }}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Facility</Form.Label>
                <ThemedSelect
                  name="facility"
                  closeMenuOnSelect={true}
                  placeholder='All Facilities'
                  classNamePrefix="react-select"
                  options={facilityOptions}
                  value={selectedFacilityValue}
                  getOptionLabel={option => option.key}
                  getOptionValue={option => option.value}
                  onChange={(e) => handleFacilityChange(e)}
                />
              </Form.Group>
            </Col>
          </Row>
        </div>
      </Card>
      {isError ? (
        <Alert variant="info" className="text-center fw-bold">
          No Data found.
        </Alert>
      ) : (
        <Row className='m-0' style={pageNumber === 0 ? { opacity: 0.85 } : {}}>
          {Object.keys(filteredCycleData).map(date => (
            <Col xs={2} className='dayCols px-1'>
              <Card>
                <Card.Header className='dateCol text-white card-header text-center p-2'>
                  {moment(date, 'YYYY-MM-DD').format('MM/DD/YY')} [{cycleDates[date]?.total}]
                  <br />
                  PV2 [{cycleDates[date]?.pv2Count}]
                </Card.Header>
                <Card.Body className='px-1 cycleViewCardBody' >
                  {filteredCycleData[date]?.map((item, index) => (
                    <>
                      {item.need_acknowledgement == 0 && <Card className='cycleViewCard my-2' id={"cycleViewCard" + item.id} name={"cycleViewCard" + item.id} role="button" >
                        <Card.Header className={item.bgColor + ' px-3 py-1 ' + item.fgColorHeader} onClick={() => handleCardBodyClick(item.facility_id)}>
                          {item.facility_name}
                        </Card.Header>
                        <Card.Body className={item.bgColor + '-body text-dark px-3 py-1'}  >

                        <Row>
                          {/* <Col xs="6 " onClick={() => handleCardBodyClick(item.facility_id)}>
                            {item.need_refill > 0 && <OverlayTrigger
                              overlay={
                                <Tooltip style={{ position: 'fixed' }} >
                                  {item.need_refill_drugs.map((drug, index) => (
                                    <div key={index}>{drug} </div>
                                  ))}
                                </Tooltip>
                              }
                            >
                              <u class='refill-tooltip fw-bold'> Need Refill: {item.need_refill}</u>
                            </OverlayTrigger>}

                              {item.need_refill == 0 &&
                                <span> Need Refill: {item.need_refill}</span>
                              }

                            </Col>
                            <Col xs="6" className='text-end' onClick={() => handleCardBodyClick(item.facility_id)}>
                              {item.on_hold > 0 && <OverlayTrigger
                                overlay={
                                  <Tooltip style={{ position: 'fixed' }} >
                                    {item.on_hold_drugs?.map((drug, index) => (
                                      <div key={index}>{drug} </div>
                                    ))}
                                  </Tooltip>
                                }
                              >
                                <u class='refill-tooltip fw-bold'>  On Hold: {item.on_hold}</u>
                              </OverlayTrigger>}

                            {item.on_hold == 0 &&
                              <span> On Hold: {item.on_hold}</span>
                            }
                          </Col> */}
                          <Col className='text-end' onClick={() => handleCardBodyClick(item.facility_id)}>
                            {(item.on_hold > 0 || item.need_refill > 0 || item.missingrxs > 0) && <OverlayTrigger
                              overlay={
                                <Tooltip style={{ position: 'fixed' }} >
                                  {item.on_hold_drugs?.map((drug, index) => (
                                    <div key={index}>{drug} </div>
                                  ))}
                                  {item.need_refill_drugs.map((drug, index) => (
                                    <div key={index}>{drug} </div>
                                  ))}
                                  {item.missingrxs_drugs.map((drug, index) => (
                                    <div key={index}>{drug} </div>
                                  ))}
                                </Tooltip>
                              }
                            >
                              <u class='refill-tooltip fw-bold'>  Missing Rx: {item.need_refill + item.on_hold + item.missingrxs}</u>
                            </OverlayTrigger>}
                            {item.on_hold == 0 && item.need_refill == 0 && item.missingrxs == 0 &&
                              <span> Missing Rx: {item.need_refill + item.on_hold + item.missingrxs}</span>
                            }
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="6">
                            Robot: {getRobotDisplayName(item?.robot)}
                          </Col>
                          <Col xs="6" className='text-end'>
                            {
                              item.total_changed_prescriptions > 0 &&
                              <span>Cycle:&nbsp;
                                {item.updated_changed_prescriptions}
                                &nbsp;out of&nbsp;
                                {item.total_changed_prescriptions}
                              </span>
                            }
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12">
                            Delivery Time: {item.delivery_time}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12">
                            Cycle: {moment(item.cycle_start_date, 'YYYY-MM-DD').format('MM/DD/YY')} to {moment(item.cycle_end_date, 'YYYY-MM-DD').format('MM/DD/YY')}
                          </Col>
                        </Row>
                        <Row className="cycle-chks">
                          <Col xs="auto" className='col1'>
                            <div class="form-check-inline me-0">
                              {item.census == 0 && (<FontAwesomeIcon className="text-disable" icon="times-circle" />)}
                              {item.census == 1 && (<FontAwesomeIcon className="text-success" icon="check-circle" />)}
                              &nbsp;Census
                            </div>
                          </Col>

                          <Col xs="auto" className='col2'>

                            <div class="form-check-inline me-0">
                              {/* {item.liaison == 0 && (<FontAwesomeIcon className="text-disable" icon="times-circle" />)} Liaison
                              {item.liaison == 1 && (<FontAwesomeIcon className="text-success" icon="check-circle" />)} Liaison */}

                              {/* <FontAwesomeIcon className="text-disable" icon="times-circle" /> Liaison */}
                              <FontAwesomeIcon className="text-success" icon="check-circle" /> Liaison
                            </div>

                          </Col>
                        </Row>
                        <Row className="cycle-chks">
                          <Col xs="auto" className='col1'>
                            <Form.Group class="form-check-inline">
                              {/* <Form.Check
                                    type='checkbox'
                                    data-deliverydate={date}
                                    data-headerid={item.id}
                                    data-checktype="refill"
                                    name={"is_refill"+ item.id}
                                    id={"is_refill"+ item.id}
                                    checked={cycleDataIdwise[item.id].refill == 1? true : false}
                                    label='Refill'
                                    onChange={(e) => {
                                        handleCheckboxChange(e);
                                    }}
                                /> */}
                                <input
                                  type='checkbox'
                                  className='form-check-input'
                                  data-deliverydate={date}
                                  data-headerid={item.id}
                                  data-checktype="refill"
                                  name={"is_refill" + item.id}
                                  id={"is_refill" + item.id}
                                  checked={item.refill}
                                  disabled={isCycleStageDisabled(item, 'refill')}
                                  onChange={(e) => {
                                    handleCheckboxChange(e);
                                  }}
                                />
                                <label title="" for={"is_refill" + item.id} class="form-check-label">&nbsp;Refill</label>
                              </Form.Group>
                            </Col>
                            <Col xs="auto" className='col2'>
                              <Form.Group class="form-check-inline">

                                <input
                                  type='checkbox'
                                  className='form-check-input'
                                  data-deliverydate={date}
                                  data-headerid={item.id}
                                  data-checktype="billed"
                                  name={"chkBilled" + item.id}
                                  id={"chkBilled" + item.id}
                                  checked={item.billed_status}
                                  disabled={isCycleStageDisabled(item, 'billed')}
                                  onChange={(e) => {
                                    handleCheckboxChange(e);
                                  }}
                                />
                                <label title="" for={"chkBilled" + item.id} class="form-check-label">&nbsp;Billed</label>

                                {/* <Form.Check                                
                                    type='checkbox'
                                    data-deliverydate={date}
                                    data-headerid={item.id}
                                    data-checktype="billed"
                                    name={"chkBilled"+ item.id}
                                    id={"chkBilled"+ item.id}
                                    value={item.billed_status}
                                    checked={cycleDataIdwise[item.id].billed_status == 1? true : false}
                                    label='Billed'
                                    onChange={(e) => {
                                        handleCheckboxChange(e);
                                    }}
                                /> */}
                              </Form.Group>
                            </Col>

                            <Col xs="auto" >

                              <Form.Group class="form-check-inline">
                                <input
                                  type='checkbox'
                                  className='form-check-input'
                                  data-deliverydate={date}
                                  data-headerid={item.id}
                                  data-checktype="tcgrx"
                                  name={"chkTcgrx" + item.id}
                                  id={"chkTcgrx" + item.id}
                                  checked={item.tcgrx_fill}
                                  disabled={isCycleStageDisabled(item, 'tcgrx')}
                                  onChange={(e) => {
                                    handleCheckboxChange(e);
                                  }}
                                />
                                <label title="" for={"chkTcgrx" + item.id} class="form-check-label">&nbsp;Robot</label>



                                {/* <Form.Check                                
                                    type='checkbox'
                                    data-deliverydate={date}
                                    data-headerid={item.id}
                                    data-checktype="tcgrx"
                                    name={"chkTCGRx+"+ item.id}
                                    id={"chkTCGRx+"+ item.id}
                                    value={item.tcgrx_fill}
                                    checked={cycleDataIdwise[item.id].tcgrx_fill == 1? true : false}
                                    label=' Robot'
                                    onChange={(e) => {
                                        handleCheckboxChange(e);
                                    }}
                                /> */}
                              </Form.Group>

                            </Col>

                            <Col xs="auto" className='col1'>



                              <Form.Group class="form-check-inline">
                                <input
                                  type='checkbox'
                                  className='form-check-input'
                                  data-deliverydate={date}
                                  data-headerid={item.id}
                                  data-checktype="manual"
                                  name={"chkManual" + item.id}
                                  id={"chkManual" + item.id}
                                  checked={item.manual_fill == 1 || item.manual_fill === true}
                                  disabled={isCycleStageDisabled(item, 'manual')}
                                  onChange={(e) => {
                                    handleCheckboxChange(e);
                                  }}
                                />
                                <label title="" for={"chkManual" + item.id} class="form-check-label">&nbsp;Manual</label>
                              </Form.Group>


                            </Col>

                            <Col xs="auto" className='col2' >


                              <Form.Group class="form-check-inline">
                                <Form.Check
                                  type='checkbox'
                                  data-deliverydate={date}
                                  data-headerid={item.id}
                                  data-checktype="pv2"
                                  disabled={isCycleStageDisabled(item, 'pv2')}
                                  name={"chkPV2+" + item.id}
                                  id={"chkPV2+" + item.id}
                                  value={item.pv2_status}
                                  checked={item.pv2_status}
                                  label="PV2"
                                  onChange={(e) => {
                                    handleCheckboxChange(e);
                                  }}
                                />
                              </Form.Group>

                            </Col>

                            <Col xs="auto"  >

                              <Form.Group class="form-check-inline">
                                <Form.Check
                                  type='checkbox'
                                  data-deliverydate={date}
                                  data-headerid={item.id}
                                  data-checktype="manifest"
                                  name={"chkManifest+" + item.id}
                                  id={"chkManifest+" + item.id}
                                  value={item.manifest}
                                  checked={item.manifest}
                                  disabled={isCycleStageDisabled(item, 'manifest')}
                                  label=' Manifest'
                                  onChange={(e) => {
                                    handleCheckboxChange(e);
                                  }}
                                />
                              </Form.Group>


                            </Col>

                          </Row>

                        </Card.Body>
                      </Card>}

                      <div key={index}>
                        {/* {JSON.stringify(item)} Render your item properties here */}
                      </div>
                    </>
                  ))}
                </Card.Body>
              </Card>
            </Col>
          ))}
          <Col xs={2} className='px-1'>
            <Card className='h-100'>
              <Card.Header className='dateCol text-white card-header text-center p-2'>
                Updates
                <br />
                &nbsp;
              </Card.Header>
              <Card.Body className='p-1'>

              {Object.keys(filteredCycleData).map(date => (
                <>
                  {filteredCycleData[date].map((item, index) => (
                    <>
                      {item.need_acknowledgement == 1 && <Card className='cycleViewCard my-2' id={"cycleViewCard" + item.id} role="button">
                        <Card.Header className={item.bgColor + ' px-3 py-1 ' + item.fgColorHeader} onClick={() => handleUpdateCardBodyClick(item.facility_id)}>
                          {item.facility_name}
                        </Card.Header>
                        <Card.Body className={item.bgColor + '-body text-dark px-3 py-1'} >

                          <Row>
                            {/* <Col xs="6 " onClick={() => handleUpdateCardBodyClick(item.facility_id)}>
                              {item.need_refill > 0 && <OverlayTrigger
                                overlay={
                                  <Tooltip style={{ position: 'fixed' }} >
                                    {item.need_refill_drugs.map((drug, index) => (
                                      <div key={index}>{drug} </div>
                                    ))}
                                  </Tooltip>
                                }
                              >
                                <u class='refill-tooltip fw-bold'> Need Refill: {item.need_refill}</u>
                              </OverlayTrigger>}

                              {item.need_refill == 0 &&
                                <span> Need Refill: {item.need_refill}</span>
                              }

                            </Col>
                            <Col xs="6" className='text-end' onClick={() => handleUpdateCardBodyClick(item.facility_id)}>
                              {item.on_hold > 0 && <OverlayTrigger
                                overlay={
                                  <Tooltip style={{ position: 'fixed' }} >
                                    {item.on_hold_drugs?.map((drug, index) => (
                                      <div key={index}>{drug} </div>
                                    ))}
                                  </Tooltip>
                                }
                              >
                                <u class='refill-tooltip fw-bold'>  On Hold: {item.on_hold}</u>
                              </OverlayTrigger>}

                              {item.on_hold == 0 &&
                                <span> On Hold: {item.on_hold}</span>
                              }
                            </Col> */}
                            <Col className='text-end' onClick={() => handleCardBodyClick(item.facility_id)}>
                            {(item.on_hold > 0 || item.need_refill > 0 || item.missingrxs > 0) && <OverlayTrigger
                              overlay={
                                <Tooltip style={{ position: 'fixed' }} >
                                  {item.on_hold_drugs?.map((drug, index) => (
                                    <div key={index}>{drug} </div>
                                  ))}
                                  {item.need_refill_drugs.map((drug, index) => (
                                    <div key={index}>{drug} </div>
                                  ))}
                                  {item.missingrxs_drugs.map((drug, index) => (
                                    <div key={index}>{drug} </div>
                                  ))}
                                </Tooltip>
                              }
                            >
                              <u class='refill-tooltip fw-bold'>  Missing Rx: {item.need_refill + item.on_hold + item.missingrxs}</u>
                            </OverlayTrigger>}
                            {item.on_hold == 0 && item.need_refill == 0 && item.missingrxs == 0 &&
                              <span> Missing Rx: {item.need_refill + item.on_hold + item.missingrxs}</span>
                            }
                          </Col>
                          </Row>
                          <Row>
                            <Col xs="6">
                              Robot: {getRobotDisplayName(item?.robot)}
                            </Col>
                            <Col xs="6" className='text-end'>
                              {
                                item.total_changed_prescriptions > 0 &&
                                <span>Cycle:&nbsp;
                                  {item.updated_changed_prescriptions}
                                  &nbsp;out of&nbsp;
                                  {item.total_changed_prescriptions}
                                </span>
                              }
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="12">
                              Delivery Time: {item.delivery_time}
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="12">
                              Cycle: {moment(item.cycle_start_date, 'YYYY-MM-DD').format('MM/DD/YY')} to {moment(item.cycle_end_date, 'YYYY-MM-DD').format('MM/DD/YY')}
                            </Col>
                          </Row>
                          <Row className="cycle-chks">
                            <Col xs="auto" className='col1'>
                              <div class="form-check-inline me-0">
                                {item.census == 0 && (<FontAwesomeIcon className="text-disable" icon="times-circle" />)}
                                {item.census == 1 && (<FontAwesomeIcon className="text-success" icon="check-circle" />)}
                                &nbsp;Census
                              </div>
                            </Col>

                              <Col xs="auto" className='col2'>

                                <div class="form-check-inline me-0">
                                  {/* {item.liaison == 0 && (<FontAwesomeIcon className="text-disable" icon="times-circle" />)} Liaison
                              {item.liaison == 1 && (<FontAwesomeIcon className="text-success" icon="check-circle" />)} Liaison */}

                                  {/* <FontAwesomeIcon className="text-disable" icon="times-circle" /> Liaison */}
                                  <FontAwesomeIcon className="text-success" icon="check-circle" /> Liaison
                                </div>

                              </Col>
                            </Row>
                            <Row className="cycle-chks">
                              <Col xs="auto" className=''>
                                <Form.Group class="form-check-inline">
                                  {/* <Form.Check
                                    type='checkbox'
                                    data-deliverydate={date}
                                    data-headerid={item.id}
                                    data-checktype="refill"
                                    name={"is_refill"+ item.id}
                                    id={"is_refill"+ item.id}
                                    checked={cycleDataIdwise[item.id].refill == 1? true : false}
                                    label='Refill'
                                    onChange={(e) => {
                                        handleCheckboxChange(e);
                                    }}
                                /> */}
                                  <input
                                    type='checkbox'
                                    className='form-check-input'
                                    data-deliverydate={date}
                                    data-headerid={item.id}
                                    data-checktype="acknowledged"
                                    name={"is_acknowledged" + item.id}
                                    id={"is_acknowledged" + item.id}
                                    onChange={(e) => {
                                      handleAcknowledgeChange(e);
                                    }}
                                  />
                                  <label title="" for={"is_acknowledged" + item.id} class="form-check-label">&nbsp;Acknowledged</label>
                                </Form.Group>
                              </Col>









                            </Row>

                          </Card.Body>
                        </Card>}

                      </>
                    ))}
                  </>
                ))}




              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
      {(() => {
        const currentIndex = weekPages.indexOf(pageNumber) !== 0 ? weekPages.indexOf(pageNumber) : 1;
        return (
          <div className="d-flex justify-content-between mt-4">
            <Button
              variant="primary"
              disabled={currentIndex === 0}
              onClick={() => handlePageChange(weekPages[currentIndex - 1])}
            >
              Previous Page
            </Button>
            <Button
              variant="primary"
              disabled={currentIndex === weekPages.length - 1}
              onClick={() => handlePageChange(weekPages[currentIndex + 1])}
            >
              Next Page
            </Button>
          </div>
        );
      })()}
    </>
  );
};

export default CycleView;
